import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CheckIcon, UsersIcon, GlobeIcon, ShoppingBagIcon, HeartIcon } from 'lucide-react';
export const AboutPage = () => {
  const [scrolled, setScrolled] = useState(false);
  // Team members
  const teamMembers = [{
    name: 'Sarah Johnson',
    role: 'CEO & Founder',
    image: 'https://randomuser.me/api/portraits/women/44.jpg',
    bio: 'Former designer with a passion for empowering creators.'
  }, {
    name: 'Michael Chen',
    role: 'CTO',
    image: 'https://randomuser.me/api/portraits/men/32.jpg',
    bio: 'Tech leader focused on building scalable marketplace solutions.'
  }, {
    name: 'Emily Rodriguez',
    role: 'Head of Product',
    image: 'https://randomuser.me/api/portraits/women/28.jpg',
    bio: 'Product strategist with experience at top tech companies.'
  }, {
    name: 'David Wilson',
    role: 'Marketing Director',
    image: 'https://randomuser.me/api/portraits/men/22.jpg',
    bio: 'Digital marketing expert specializing in creator economies.'
  }];
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-3044">
      <Navbar scrolled={scrolled} data-id="element-3045" />
      <main className="pt-24 pb-20" data-id="element-3046">
        <div className="container mx-auto px-4 md:px-6" data-id="element-3047">
          <div className="max-w-6xl mx-auto" data-id="element-3048">
            {/* Hero Section */}
            <div className="text-center mb-16" data-id="element-3049">
              <h1 className="text-3xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] text-transparent bg-clip-text" data-id="element-3050">
                About{' '}
                <span className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] text-transparent bg-clip-text" data-id="element-3051">
                  DG
                </span>
                <span className="bg-gradient-to-r from-[#2DB489] to-[#3DC79D] dark:from-[#4ED1A0] dark:to-[#6FDEBB] text-transparent bg-clip-text" data-id="element-3052">
                  Stack
                </span>
              </h1>
              <p className="text-xl text-gray-600 dark:text-[#B0C1BD] max-w-3xl mx-auto" data-id="element-3053">
                DGStack is a global platform that empowers digital creators to
                share and monetize their work while helping buyers find
                high-quality digital products.
              </p>
            </div>
            {/* Mission Section */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 md:p-12 shadow-sm mb-16" data-id="element-3054">
              <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-3055">
                <div className="md:w-1/2" data-id="element-3056">
                  <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-3057">
                    Our Mission
                  </h2>
                  <p className="text-gray-600 dark:text-[#B0C1BD] mb-6" data-id="element-3058">
                    We're on a mission to create the most creator-friendly
                    marketplace for digital products. We believe in fair
                    compensation for creators and high-quality resources for
                    buyers.
                  </p>
                  <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-3059">
                    Founded in 2020, DGStack has grown from a small community of
                    designers to a global platform hosting thousands of digital
                    products from creators around the world.
                  </p>
                </div>
                <div className="md:w-1/2" data-id="element-3060">
                  <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Team collaboration" className="rounded-xl w-full h-auto object-cover" data-id="element-3061" />
                </div>
              </div>
            </div>
            {/* Stats Section */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-16" data-id="element-3062">
              <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm text-center" data-id="element-3063">
                <UsersIcon className="h-10 w-10 mx-auto text-[#2DB489] dark:text-[#4ED1A0] mb-3" data-id="element-3064" />
                <h3 className="text-3xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-1" data-id="element-3065">
                  10K+
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-3066">Creators</p>
              </div>
              <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm text-center" data-id="element-3067">
                <ShoppingBagIcon className="h-10 w-10 mx-auto text-[#2DB489] dark:text-[#4ED1A0] mb-3" data-id="element-3068" />
                <h3 className="text-3xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-1" data-id="element-3069">
                  50K+
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-3070">Products</p>
              </div>
              <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm text-center" data-id="element-3071">
                <GlobeIcon className="h-10 w-10 mx-auto text-[#2DB489] dark:text-[#4ED1A0] mb-3" data-id="element-3072" />
                <h3 className="text-3xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-1" data-id="element-3073">
                  120+
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-3074">Countries</p>
              </div>
              <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm text-center" data-id="element-3075">
                <HeartIcon className="h-10 w-10 mx-auto text-[#2DB489] dark:text-[#4ED1A0] mb-3" data-id="element-3076" />
                <h3 className="text-3xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-1" data-id="element-3077">
                  98%
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-3078">
                  Satisfaction
                </p>
              </div>
            </div>
            {/* Values Section */}
            <div className="mb-16" data-id="element-3079">
              <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center text-gray-800 dark:text-[#F8FAF9]" data-id="element-3080">
                Our Values
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-3081">
                <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm" data-id="element-3082">
                  <div className="w-12 h-12 rounded-full bg-[#2DB489]/10 flex items-center justify-center mb-4" data-id="element-3083">
                    <CheckIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-3084" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-3085">
                    Quality First
                  </h3>
                  <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-3086">
                    We maintain high standards for all products on our platform,
                    ensuring buyers always get exceptional value.
                  </p>
                </div>
                <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm" data-id="element-3087">
                  <div className="w-12 h-12 rounded-full bg-[#2DB489]/10 flex items-center justify-center mb-4" data-id="element-3088">
                    <CheckIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-3089" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-3090">
                    Creator Success
                  </h3>
                  <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-3091">
                    We're committed to helping creators succeed with fair
                    compensation, powerful tools, and valuable resources.
                  </p>
                </div>
                <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm" data-id="element-3092">
                  <div className="w-12 h-12 rounded-full bg-[#2DB489]/10 flex items-center justify-center mb-4" data-id="element-3093">
                    <CheckIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-3094" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-3095">
                    Community
                  </h3>
                  <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-3096">
                    We foster a supportive community where creators can connect,
                    collaborate, and grow together.
                  </p>
                </div>
              </div>
            </div>
            {/* Team Section */}
            <div className="mb-16" data-id="element-3097">
              <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center text-gray-800 dark:text-[#F8FAF9]" data-id="element-3098">
                Meet Our Team
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-3099">
                {teamMembers.map((member, index) => <div key={index} className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm text-center" data-id="element-3100">
                    <div className="w-24 h-24 rounded-full overflow-hidden mx-auto mb-4" data-id="element-3101">
                      <img src={member.image} alt={member.name} className="w-full h-full object-cover" data-id="element-3102" />
                    </div>
                    <h3 className="text-lg font-semibold mb-1 text-gray-800 dark:text-[#F8FAF9]" data-id="element-3103">
                      {member.name}
                    </h3>
                    <p className="text-[#2DB489] dark:text-[#4ED1A0] font-medium mb-3" data-id="element-3104">
                      {member.role}
                    </p>
                    <p className="text-gray-600 dark:text-[#B0C1BD] text-sm" data-id="element-3105">
                      {member.bio}
                    </p>
                  </div>)}
              </div>
            </div>
            {/* Join Us CTA */}
            <div className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 md:p-12 text-white text-center" data-id="element-3106">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-3107">
                Join Our Journey
              </h2>
              <p className="text-lg opacity-90 mb-8 max-w-3xl mx-auto" data-id="element-3108">
                Whether you're a creator looking to share your work or a buyer
                seeking quality digital products, we'd love to have you as part
                of our community.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-3109">
                <button className="bg-white text-[#0A3C52] px-8 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors" data-id="element-3110">
                  Start Selling
                </button>
                <button className="bg-transparent border border-white text-white px-8 py-3 rounded-lg font-medium hover:bg-white/10 transition-colors" data-id="element-3111">
                  Explore Products
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-3112" />
    </div>;
};